/**
 * いくつかの中から1つを選ぶ切り替え(日次/週次/月次、管理者込み/抜き、表示の単位など)。業務ロジックは持たない。
 * 選択中は aria-pressed。Tab で各ボタンに移り Enter / Space で選ぶ。
 */
export type SegmentOption<K extends string> = { key: K; label: string };

export default function SegmentedControl<K extends string>({
  label,
  options,
  value,
  onChange,
  showLabel = false,
  size = 'md',
}: {
  /** 何を切り替えるか(読み上げ用。showLabel で画面にも出す) */
  label: string;
  options: SegmentOption<K>[];
  value: K;
  onChange: (key: K) => void;
  showLabel?: boolean;
  size?: 'md' | 'sm';
}) {
  return (
    <div className={`ui-seg-wrap${size === 'sm' ? ' is-sm' : ''}`}>
      {showLabel && <span className="ui-seg-label">{label}</span>}
      <div className="ui-seg" role="group" aria-label={label}>
        {options.map((o) => (
          <button key={o.key} type="button" className="ui-seg-btn" aria-pressed={o.key === value} onClick={() => o.key !== value && onChange(o.key)}>
            {o.label}
          </button>
        ))}
      </div>
    </div>
  );
}
